import { Box, SxProps, Theme, useTheme } from "@mui/material";
import React from "react";
import Button from "../../common/forms/button";

type Props = {
  onSignaturesClick?: () => void;
  onVersionsClick?: () => void;
};

const DocumentActions = ({ onSignaturesClick, onVersionsClick }: Props) => {
  const theme = useTheme();

  const documentActionsContainer: SxProps<Theme> = {
    height: "100px",
    display: "flex",
    flexDirection: "column",
    borderTop: `1px solid ${theme.palette.tertiary.main}`,
    justifyContent: "center",
    alignItems: "center",
  };

  return (
    <Box sx={documentActionsContainer}>
      {onSignaturesClick && (
        <Button
          onClick={onSignaturesClick}
          data-testid="document-action-viewSignatures"
        >
          view signatures
        </Button>
      )}
      {onVersionsClick && (
        <Button
          onClick={onVersionsClick}
          data-testid="document-action-viewVersions"
        >
          view versions
        </Button>
      )}
    </Box>
  );
};

export default DocumentActions;
